import { HttpRequest } from "./utils/HttpRequest";
import { Mrz } from "./models/Mrz";

export default class Pass {
  httpReq = new HttpRequest();
  //Services
  findPassByLPQR(token: string, qr: string): Promise<any> {
    return this.httpReq.post(`ws-security/previewInvite`, {
      token,
      qr,
    });
  }

  findPassByMRZ(token: string, mrz: Mrz): Promise<any> {
    return this.httpReq.get(`ws-security/findUser-MRZ`, {
      token: token,
      mrz: mrz,
    });
  }
}
